<div fxLayout="row" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Company' | translate }}</mat-label>
      <input matInput formControlName="company" placeholder="{{ 'Company' | translate }}"
        [matAutocomplete]="autocompleteCompany" [errorStateMatcher]="matcher" tabindex="1" />
      <mat-autocomplete #autocompleteCompany="matAutocomplete" [displayWith]="displayValue">
        @for (company of companies$ | async; track company) {
        <mat-option [value]="company">
          {{ company.Name }}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'Pesel' | translate }}</mat-label>
      <input matInput type="text" formControlName="pesel" tabindex="4" />
    </mat-form-field>

    <div class="control">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'WL-AgreementStatus' | translate }}</mat-label>
        <mat-select formControlName="agreementStatusId" multiple tabindex="7">
          @for (status of agreementStatuses$ | async; track status) {
          <mat-option #matOption [value]="status.Id">{{ status.Name | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Second column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Employer' | translate }}</mat-label>
      <input matInput formControlName="employer" [placeholder]="'Employer' | translate"
        [matAutocomplete]="autocompleteEmployer" [errorStateMatcher]="matcher" tabindex="2" />
      <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue">
        @for (employer of employers$ | async; track employer) {
        <mat-option [value]="employer">
          {{ employer.Name }}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>{{ 'LastName' | translate }}</mat-label>
      <input matInput type="text" formControlName="lastName" tabindex="4" />
    </mat-form-field>

    <div class="control">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'HolidayPerMonthListFilters.AbsenceStatus' | translate }}</mat-label>
        <mat-select formControlName="absenceStatusId" multiple tabindex="8">
          @for (status of absenceStatuses$ | async; track status) {
          <mat-option #matOption [value]="status.Id">{{ status.Name | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Third column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
      <input matInput formControlName="employerObject" [placeholder]="'EmployerObject' | translate"
        [matAutocomplete]="autocompleteEmployerObject" [errorStateMatcher]="matcher" tabindex="3" />
      <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
        @for (employerObject of employerObjects$ | async; track employerObject) {
        <mat-option [value]="employerObject">
          {{ employerObject.Name }}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'FirstName' | translate }}</mat-label>
      <input matInput type="text" formControlName="firstName" tabindex="6" />
    </mat-form-field>

    <div class="control">
      <ng-content></ng-content>
    </div>
  </div>
</div>